<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="5">
            <span style="font-size: 16px; font-weight: bold">
              系統記錄查詢
            </span>
             <span style="font-size: 12px; font-weight: bold">
              (僅保留180天)
            </span>
          </el-col>
        </el-row>
      </div>

      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column
          prop="importance"
          label="重要性"
          width="100"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="eventName"
          label="事件名稱"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="message"
          label="事件內容"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="date"
          label="事件時間"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ getdate(scope.row.date) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="user"
          label="操作者"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>

          <el-table-column
          prop="source"
          label="事件來源"
          header-align="center"
          align="center"
        >
        </el-table-column>

      </el-table>
    </el-card>
  </div>
</template>

<script>
import API from "../api";
// eslint-disable-next-line no-undef
var moment = require("moment-timezone");

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "EventsLog",

  data() {
    return {
      isLoading: false,
      tableData: [],
      ldate:"",
   
      qString: "",
    };
  },

  created() {
    this.ldate = moment.tz.guess();
    this.query();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.eventsLog.query().then((res) => {
        // console.log(res.data);
        this.tableData = res.data;
        this.isLoading = false;
      });
    },
    getdate(date) {
      var a = moment.tz(date, this.ldate);
      return a.format("YYYY-MM-DD hh:mm:ss a");
    },
  }
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>